import { Link } from "react-router-dom";
import { Lock, ShoppingCart } from "lucide-react";
import Logo, { WhatsAppIcon } from "../Logo";
import { waLink } from "../../api";
import { useCart } from "../../CartContext";

const NAV_LINKS = [
  { href: "#catalogo", label: "Catálogo" },
  { href: "#marcas", label: "Marcas" },
  { href: "#nosotros", label: "Nosotros" },
  { href: "#opiniones", label: "Opiniones" },
  { href: "#referidos", label: "Referidos" },
  { href: "#pago", label: "Pago y envío" },
];

export default function Header() {
  const { count, setIsOpen } = useCart();

  return (
    <header
      data-testid="public-header"
      className="fixed top-0 z-50 w-full border-b border-[#2D323E] bg-[#16181D]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 lg:px-8">
        <a href="#inicio" data-testid="nav-logo-link" aria-label="NubeVape España">
          <Logo />
        </a>
        <nav className="hidden items-center gap-7 md:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-medium text-[#8A8F98] transition-colors hover:text-[#2EE6D6]"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setIsOpen(true)}
            data-testid="header-cart-btn"
            aria-label="Abrir carrito"
            className="relative rounded-full p-2.5 text-[#8A8F98] transition-colors hover:bg-[#1E2128] hover:text-[#F2F4F6]"
          >
            <ShoppingCart className="h-5 w-5" />
            {count > 0 && (
              <span
                data-testid="header-cart-count"
                className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-gradient-to-r from-[#2EE6D6] to-[#7C5CFF] px-1 text-[10px] font-bold text-black"
              >
                {count}
              </span>
            )}
          </button>
          <Link
            to="/admin"
            data-testid="header-admin-link"
            aria-label="Panel de administración"
            className="rounded-full p-2.5 text-[#8A8F98] transition-colors hover:bg-[#1E2128] hover:text-[#F2F4F6]"
          >
            <Lock className="h-4 w-4" />
          </Link>
          <a
            href={waLink("Hola NubeVape España, quiero hacer un pedido.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
            className="flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2.5 text-sm font-bold text-black shadow-[0_4px_14px_rgba(37,211,102,0.3)] transition-all hover:bg-[#20BA5A] hover:shadow-[0_6px_20px_rgba(37,211,102,0.45)]"
          >
            <WhatsAppIcon className="h-4 w-4" />
            <span className="hidden sm:inline">Pedir por WhatsApp</span>
            <span className="sm:hidden">Pedir</span>
          </a>
        </div>
      </div>
    </header>
  );
}
